<template>
  <div class="card-filter">
    <el-row
      type="flex"
      align="start"
      justify="space-between"
      class="flex-wrap mb-l"
    >
      <el-row
type="flex"
align="middle">
        <el-select
          v-model="group"
          size="small"
          class="w-100 mr-m"
          placeholder="Nhóm hiển thị"
          @change="searchNormal"
        >
          <el-option
label="Tất cả"
value="" />
          <el-option
            v-for="item in groups"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          />
        </el-select>
        <el-select
          v-model="type"
          size="small"
          class="w-100 mr-m"
          placeholder="Loại hiển thị"
          @change="searchNormal"
        >
          <el-option
label="Tất cả"
value="" />
          <el-option
            v-for="item in typeOptions"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
        <el-input
          v-model="textSearch"
          class="text-search mr-m"
          size="small"
          placeholder="Nhập thông tin để tìm kiếm"
          clearable
        />
        <el-button
          size="small"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchNormal"
        >
          Tìm kiếm
        </el-button>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import CONSTANTS from "@/config/constants";

export default {
  name: "CardFilter",
  props: {
    typeKey: String,
    groupKey: String,
    groups: Array,
    object: Object,
  },
  data() {
    return {
      group: this.groupKey,
      type: this.typeKey,
      textSearch: "",
    };
  },
  computed: {
    typeOptions() {
      if (this.object.type === "categories") {
        return CONSTANTS.FIELD_TYPES.slice(0, 5);
      }
      return CONSTANTS.FIELD_TYPES;
    }
  },
  methods: {
    searchNormal() {
      this.$emit("search", {
        searchText: this.textSearch,
        type: this.type,
        group: this.group,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-filter {
  .text-search {
    min-width: 200px;
  }
}
</style>
